import { Outlet } from 'react-router-dom';
import SalesMenu from './SalesMenu';

function SalesReturnsLayout() {
  return (
    <div className="sales-returns-layout">
      <SalesMenu />
      <div className="returns-content">
        <h2>Returns & Refunds</h2>
        <div className="returns-container">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default SalesReturnsLayout;
